import { render, staticRenderFns } from "./MessageEditForm.vue?vue&type=template&id=2ffd9e66&scoped=true&"
import script from "./MessageEditForm.vue?vue&type=script&lang=ts&"
export * from "./MessageEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./MessageEditForm.vue?vue&type=style&index=0&id=2ffd9e66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffd9e66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFadeTransition})
